import {gql} from "@apollo/client";

export const getAllergiesQuery = gql`
  query getAllergies($clientId: ID!) {
    allergies( clientId: $clientId) {id, name, level}
  }
`;

export const createAllergyMutation = gql`
  mutation createAllergy($name: String!, $level: String, $clientId: ID!){
    createAllergy(
      input: {
        name: $name,
        level: $level,
        clientId: $clientId
      }) {
      allergy {
        id
      }
    }
  }
`

export const deleteAllergyMutation = gql`
  mutation deleteAllergy($id: ID!){
    deleteAllergy(
      input: {id: $id}) {
      allergy {
        id
      }
    }
  }
`